import React from 'react';

const LS_KEY = 'iot_page_size';
const PAGE_SIZES = [25, 50, 100];
const DEFAULT_PAGE_SIZE = 25;

/**
 * Reads the saved page size from localStorage.
 * Returns a valid option from PAGE_SIZES (defaults to DEFAULT_PAGE_SIZE).
 */
export function getStoredPageSize() {
    const stored = parseInt(localStorage.getItem(LS_KEY), 10);
    return PAGE_SIZES.includes(stored) ? stored : DEFAULT_PAGE_SIZE;
}

/**
 * Shared pagination controls.
 *
 * Props:
 *   page              {number}  — current 1-based page
 *   totalPages        {number}  — total pages
 *   pageSize          {number}  — current page size (25 | 50 | 100)
 *   onPageChange      {fn}      — called with new page number
 *   onPageSizeChange  {fn}      — called with new page size number
 *   totalCount        {number?} — optional total count label
 */
export default function PaginationControls({ page, totalPages, pageSize, onPageChange, onPageSizeChange, totalCount }) {
    const handleSizeChange = (e) => {
        const newSize = parseInt(e.target.value, 10);
        localStorage.setItem(LS_KEY, String(newSize));
        onPageSizeChange(newSize);
    };

    return (
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
            <div className="d-flex align-items-center gap-2">
                <label
                    htmlFor="iot-page-size-select"
                    className="mb-0"
                    style={{ fontSize: '13px', color: '#64748B', whiteSpace: 'nowrap' }}
                >
                    Rows per page:
                </label>
                <select
                    id="iot-page-size-select"
                    value={pageSize}
                    onChange={handleSizeChange}
                    className="form-select form-select-sm"
                    style={{ width: 'auto', fontSize: '13px' }}
                >
                    {PAGE_SIZES.map(size => (
                        <option key={size} value={size}>{size}</option>
                    ))}
                </select>
                {totalCount != null && (
                    <span style={{ fontSize: '12px', color: '#94A3B8' }}>
                        {totalCount.toLocaleString()} total
                    </span>
                )}
            </div>

            {totalPages > 1 && (
                <div className="d-flex align-items-center gap-2">
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => onPageChange(Math.max(1, page - 1))}
                        disabled={page <= 1}
                    >
                        Previous
                    </button>
                    <span style={{ fontSize: '13px', color: '#64748B', whiteSpace: 'nowrap' }}>
                        Page {page} of {totalPages}
                    </span>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
                        disabled={page >= totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
}
